export default {
  metrics: {
    go_lives: 'Gesamtzahl der Go Lives',
    avg_quality_score: 'Durchschnittlicher Qualitätswert',
    managers: {
      title: 'Onboarding-Manager',
      fields: {
        name: 'Name des Managers',
        go_lives: 'Go Lives',
        avg_quality_score: 'Durchschnittliche Qualitätsbewertung',
      },
    },
  },
  details: {
    name: 'Restaurant',
    owner: 'Name des Eigentümers',
    owner_phone: 'Telefonnummer des Eigentümers',
    owner_email: 'E-Mail des Eigentümers',
    live_from: 'Go-Live-Datum',
    onboarding_manager: 'Onboarding-Manager',
    sales_manager: 'Vertriebsleiter',
    onboarding_quality_score: 'Qualitätswert',
    export_csv: 'CSV exportieren',
  },
};
